var map = {
	"./bg/strings.json": 1939,
	"./cs/strings.json": 1940,
	"./da/strings.json": 1941,
	"./de/strings.json": 1942,
	"./el/strings.json": 1943,
	"./es-ES/strings.json": 1944,
	"./es-LA/strings.json": 1945,
	"./et/strings.json": 1946,
	"./fi/strings.json": 1947,
	"./fr-CA/strings.json": 1948,
	"./fr/strings.json": 1949,
	"./it/strings.json": 1950,
	"./lt/strings.json": 1951,
	"./lv/strings.json": 1952,
	"./nl/strings.json": 1953,
	"./no/strings.json": 1954,
	"./pl/strings.json": 1955,
	"./pseudo/strings.json": 1956,
	"./pt/strings.json": 1957,
	"./ro/strings.json": 1958,
	"./sk/strings.json": 1959,
	"./sl/strings.json": 1960,
	"./sv/strings.json": 1961,
	"./zh-CN/strings.json": 1962,
	"./zh-TW/strings.json": 1963
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1938;